import styled from "styled-components";
import { ColorVariables } from "manifest-components/src/Colors";
import { useEffect, useState } from "react";

type FullScreenLoaderProps = {
  show: boolean;
};

// Got this from :https://codepen.io/SH-Shafi/pen/zYrRMYP
// Super cool loader
const StyledFullScreenLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background-color: ${ColorVariables.cream};
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .loader {
    position: relative;
    width: 10vw;
    height: 5vw;
    padding: 1.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader span {
    position: absolute;
    height: 0.8vw;
    width: 0.8vw;
    border-radius: 50%;
    background-color: ${ColorVariables.coco};
  }

  .loader span:nth-child(1) {
    animation: loading-dotsA 0.5s infinite linear;
  }

  .loader span:nth-child(2) {
    animation: loading-dotsB 0.5s infinite linear;
  }

  @keyframes loading-dotsA {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(2vw);
    }
    50% {
      transform: none;
    }
    75% {
      transform: translateY(2vw);
    }
    100% {
      transform: none;
    }
  }

  @keyframes loading-dotsB {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(-2vw);
    }
    50% {
      transform: none;
    }
    75% {
      transform: translateY(-2vw);
    }
    100% {
      transform: none;
    }
  }
`;

export const FullScreenLoader = (props: FullScreenLoaderProps) => {
  const [show, setShow] = useState(props.show);

  useEffect(() => {
    if (!props.show) {
      setTimeout(() => {
        if (!props.show) {
          setShow(false);
        }
      }, 500);
    } else {
      setShow(true);
    }
  }, [props.show]);

  if (!show) return null;
  return (
    <StyledFullScreenLoader className="loader-div">
      <span className="loader">
        <span />
        <span />
      </span>
    </StyledFullScreenLoader>
  );
};
